import React, {useContext, useEffect, useRef, useState} from 'react';
import {useSharedExperiencesApi} from '../lib/useSharedExperiencesApi';
import {Button, Divider, Icon, IconButton, Skeleton, Tag} from '@chakra-ui/react';
import SharedExperienceListItem from './sharedExperienceListItem';
import {Box, Flex, Stack, Text} from '@chakra-ui/layout';
import {MdAdd} from 'react-icons/md';
import SharedExperienceIcon from '../../components/icons/sharedExperienceIcon';
import {useDisclosure} from '@chakra-ui/react-use-disclosure';
import { useNavigate } from 'react-router-dom';
import {Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay} from '@chakra-ui/modal';
import SharedExperienceForm from './sharedExperienceForm';
import { OrganisationContext } from '../../organisation/lib/organisationContext';
import { AuthContext } from '../../auth/lib/authContext';
import ProfileProvider from '../../profile/lib/profileProvider';
import useTranslation from '../../lib/i18n/useTranslation';

export default function SharedExperiencesList(props) {
  const { t } = useTranslation();
  const {
    insidePaddings = true,
    emptyHeight,
    maxHeight } = props;
  const {
    organisation,
    hasOrganisation
  } = useContext(OrganisationContext)
  const {
    profile
  } = useContext(AuthContext)
  const [sharedExperiences, setSharedExperiences] = useState(null);
  const [isAdding, setIsAdding] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const sharedExperiencesApi = useSharedExperiencesApi();
  const [tab, setTab] = useState('mine');
  const [isInit, setIsInit] = useState(false);
  const {isOpen, onOpen, onClose} = useDisclosure();
  const navigate = useNavigate();
  const ref = useRef(null);
  async function getSharedExperiences() {
    setIsFetching(true);
    let newSharedExperiences;
    if(tab === 'mine') {
      newSharedExperiences = await sharedExperiencesApi.fetchSharedExperiencesByUserId(profile.id);
    } else {
      newSharedExperiences = await sharedExperiencesApi.fetchSharedExperiencesByOrganisation(organisation.id, profile.id);
    }
    if(!newSharedExperiences) {
      newSharedExperiences = [];
    }
    setSharedExperiences(newSharedExperiences);
    setIsFetching(false);
  }
  const getHeight = () => {
    if(emptyHeight) {
      return emptyHeight
    } else {
      return "100%"
    }
  }
  useEffect(() => {
    if(!isInit) {
      getSharedExperiences();
      setIsInit(true);
    }
  }, [isInit]);
  useEffect(() => {
    if(sharedExperiences) {
      getSharedExperiences();
    }
  }, [tab]);
  return (
    <>
      <Flex
        flexDirection={"column"}
        w={"100%"}
        h={"100%"}
        >
        <Flex
        alignItems='center'
        py={2}
        px={3}
        backgroundColor="white"
        borderBottom={"1px solid"}
        borderColor={"divider.grey"}
        >
          <Icon
                          as={SharedExperienceIcon}
            boxSize={'18px'}
            color={'fill.green'}
            mr={2}
            />
          <Text
            fontSize="16px"
            color="text.medium.green"
            mr={3}
          >{t('sharedExperience.sharedExperiences')}</Text>
          {(!isFetching && sharedExperiences && sharedExperiences.length > 0) && (
            <IconButton
              icon={<MdAdd />}
              aria-label='New'
              variant='greenOutline'
              onClick={onOpen}
            />
          )}
        </Flex>
        {hasOrganisation && (
            <Flex
              alignItems='center'
              py={1}
              px={3}
              backgroundColor="white"
              borderBottom={"1px solid"}
              borderColor={"divider.grey"}
              gap={1}
            >
              <Tag
                variant={(tab === 'mine' ? "green" : 'grey')}
                cursor={"pointer"}
                onClick={() => {
                  setTab('mine')
                }}
                >Mine</Tag>
              <Tag
                variant={(tab === 'organisation' ? "green" : 'grey')}
                cursor={"pointer"}
                onClick={() => {
                  setTab('organisation')
                }}
              >{organisation.name}'s</Tag>
            </Flex>
        )}
        <Flex
          overflow={"auto"}
          flexDirection={"column"}
          h={(!isFetching && sharedExperiences && sharedExperiences.length === 0) ? getHeight() : "auto"}
          p={insidePaddings ? 3 : 0}
        >
          { isFetching && (
            <Stack p={3} spacing={2} backgroundColor={'white'}>
              <Skeleton height='50px' />
              <Skeleton height='50px' />
              <Skeleton height='50px' />
            </Stack>
          )}
          <Flex
           flexDirection={"column"}
           border={(insidePaddings && sharedExperiences && sharedExperiences.length > 0) ? "1px solid" : "none"}
           borderColor="divider.grey"
           w="100%"
           h="100%"
           maxH={maxHeight}
          >
          {(!isFetching && sharedExperiences && sharedExperiences.length === 0) && (
            <Flex
              p={3}
              alignItems={'center'}
              justifyContent={'center'}
              flexDirection={'column'}
              gap={2}
              flex="1"
            >
              <Text
                color="text.medium.grey"
                fontSize={"12px"}
              >No shared experiences so far</Text>
              <Button
                onClick={onOpen}
                leftIcon={<MdAdd />}
                variant="greenOutline"
                >New Shared Experiences</Button>
            </Flex>
          )}
          { (!isFetching && sharedExperiences) && sharedExperiences.map((shexp, i) => {
            return (
              <ProfileProvider
                key={i}
                profileId={shexp.owner.id}
                originalProfile={shexp.owner}
              >
                <Box >
                  {(i > 0 && !shexp.hover) && <Divider style={{ pointerEvents: 'none' }} />}
                  {(shexp.hover && shexp.area === 'border-top') && <Divider style={{ pointerEvents: 'none' }} bg={"fill.green"} h={"2px"} />}
                  {(shexp.hover && shexp.area === 'border-bottom') && <Divider style={{ pointerEvents: 'none' }} bg={"fill.green"} h={"2px"} />}
                  <SharedExperienceListItem 
                    sharedExperiences={shexp.shared_experiences}
                    insightsCount={shexp.insights_count}
                  />
                </Box>
              </ProfileProvider>
            );
          })}
          </Flex>
        </Flex>
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>New Shared Experience</ModalHeader>
          <ModalBody >
            <Box p={3}>
              <SharedExperienceForm
                hideSave={true}
                onSubmitting={() => {
                  setIsAdding(true);
                }}
                onSubmitted={(newSharedExperience) => {
                  setIsAdding(false);
                  if (newSharedExperience && newSharedExperience.id) {
                    navigate(`/shared-experiences/${newSharedExperience.id}`);
                    onClose();
                  }
                }}
                onValidityChange={setIsValid}
                ref={ref}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='greenOutline'
              onClick={onClose}
            >{t('common.cancel')}</Button>
            <Button
              variant="greenFill"
              ml={2}
              isLoading={isAdding}
              isDisabled={!isValid}
              onClick={() => {
                ref.current.click();
              }}>{t('common.create')}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      </>
  );
} 